<div [ngClass]="{'mb-3': label.length > 0}">
    @if (label.length > 0) {
        <div class="d-flex justify-content-between">
            <label class="form-label" [class]="labelClass" [for]="id">{{ label }}</label>
            @if (information) {
                <app-popover-icon class="ms-3" [popover]="information" />
            }
        </div>
    }
    <button
        type="button"
        class="form-select"
        [disabled]="formGroup.disabled"
        [class.is-invalid]="invalid() || (ngControl.invalid === true && ngControl.touched === true)"
        placement="auto"
        container="body"
        [autoClose]="'outside'"
        popoverClass="dropdown-input"
        [ngbPopover]="popContent">
        <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex flex-wrap" style="gap: 0.25rem">
                @for (item of formGroup.controls.formArray.controls; track $index) {
                    @if (item.getRawValue().selected) {
                        <div class="badge rounded-pill text-bg-primary ps-3">
                            {{ item.value.name }}
                            @if (item.controls.selected.enabled) {
                                <button
                                    type="button"
                                    (click)="$event.stopPropagation(); setValue(item, false)"
                                    class="btn p-0 text-bg-primary"
                                    style="line-height: var(--bs-badge-font-size)">
                                    <i class="bi bi-x" tabindex="0"></i>
                                </button>
                            }
                        </div>
                    }
                }
                @if (placeholder() !== '') {
                    <span class="dropdown-placeholder text-body-secondary text-nowrap ps-2">
                        {{ placeholder() }}
                    </span>
                }
            </div>
            @if (anySelected() && formGroup.enabled) {
                <button
                    type="button"
                    (click)="$event.stopPropagation(); deselectAll()"
                    class="btn btn-text-primary p-0"
                    style="line-height: var(--bs-badge-font-size)">
                    <i class="bi bi-x" tabindex="0"></i>
                </button>
            }
        </div>
    </button>
</div>

<ng-template #popContent style="width: fit-content">
    @for (item of formGroup.controls.formArray.controls; track $index) {
        <div class="form-check">
            <input
                class="form-check-input"
                type="checkbox"
                [id]="id + '-' + $index"
                [formControl]="item.controls.selected" />
            <label
                class="form-check-label"
                [for]="id + '-' + $index"
                [title]="item.value.hint ?? ''">
                {{ item.value.name }}
            </label>
        </div>
    }
    @if (formGroup.controls.formArray.controls.length === 0) {
        {{ 'control-messages_NOTHING_TO_SELECT' | translate: 'common' : 'brunata-angular-ui' }}
    }
</ng-template>
